import React from "react";
import { ReactComponent as ChevronLeftSVG } from "assets/icons/chevron-left.svg";
import { useTranslation } from "react-i18next";
import { LinkStyled } from "./styles";


const GoBack = ({ to, className }) => {

  const { t } = useTranslation();

  return (
    <LinkStyled className={className} to={to}>
      <ChevronLeftSVG height={19} width={19} />
      {t("back")}
    </LinkStyled>
  );
}

export default GoBack;
